import { useQuery } from '@tanstack/react-query';

import { useServicesContext } from '../../../contexts/ServicesContext';

export enum GetLabelsCacheKey {
  GetLabels = 'GET_LABELS',
}

export const useGetLabelsQuery = () => {
  const { getLabels } = useServicesContext();
  return useQuery({
    queryKey: [GetLabelsCacheKey.GetLabels],
    queryFn: () => getLabels(),
  });
};
